/**
 * Created by hp on 2017/6/13.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Button, Dialog, Icon} from 'react-weui';
import axios from 'axios';
import {browserHistory} from 'react-router';

class LecturePasswordLecture extends Component {
    constructor() {
        super();
        this.onPasswordHandle = this.onPasswordHandle.bind(this);
        this.onPasswordChange = this.onPasswordChange.bind(this);
        this.onClosePwdDialog = this.onClosePwdDialog.bind(this);
        this.onOpenPwdDialog = this.onOpenPwdDialog.bind(this);
        this.onEnterClassroom = this.onEnterClassroom.bind(this);

        this.state = {
            password: '',
            pwdError: '',
            showPwdDialog: false,
            showPwdSuccessDialog: false,
            pwdDialog: {
                title: '输入密码',
                buttons: [
                    {
                        type: 'default',
                        label: '取消',
                        onClick: this.onClosePwdDialog
                    },
                    {
                        type: 'primary',
                        label: '确定',
                        onClick: this.onPasswordHandle
                    }
                ]
            },
            pwdSuccessDialog: {
                title: '',
                buttons: [
                    {
                        type: 'primary',
                        label: '进入课堂',
                        onClick: this.onEnterClassroom
                    }
                ]
            }
        }
    }

    onClosePwdDialog() {
        this.setState({showPwdDialog: false, pwdError: '', password: ''});
    }

    onOpenPwdDialog() {
        
        this.setState({showPwdDialog: true}, () => {
            this.$pwInput.focus()
        });
    }

    onPasswordHandle() {
        const {lectureId} = this.props;
        const {password} = this.state;

        let form = new FormData();
        form.append('password', password);
        axios.post(`/api/lecture/${lectureId}/check_password`, form).then((res) => {
            if (res.data.code === 0) {
                this.setState({showPwdDialog: false, showPwdSuccessDialog: true});
            } else {
                this.setState({pwdError: res.data.msg});
            }
        });
    }

    onEnterClassroom() {
        const {lectureId, lectureMode} = this.props;

        if (lectureMode === 'default'){
            window.location = `/classroom/${lectureId}`;
        }else {
            window.location = `/lecture/${lectureId}`;
        }

        // location.assign(`/classroom/${lectureId}`);
        this.props.dispatch({
            type: 'MTA_CLICK',
            payload: 'lecture_passwordenter'
        })
    }

    onPasswordChange(e) {
        this.setState({password: e.target.value});
    }

    render() {
        const {showPwdDialog, pwdDialog, password, pwdError, showPwdSuccessDialog, pwdSuccessDialog} = this.state;

        return (
            <div className="lecture-bottom-enter-btn weui-flex__item flex_4 weui-flex" style={{fontSize: '16px'}}>
                <Dialog type="ios" title={pwdDialog.title} buttons={pwdDialog.buttons} show={showPwdDialog}>
                    <input ref={r => this.$pwInput = r} className="wk-dialog-input" type="text" value={password} onChange={this.onPasswordChange} style={{fontSize: '14px'}}/>
                    <p className="wk-dialog-error">{pwdError}</p>
                </Dialog>

                <Dialog type="ios" buttons={pwdSuccessDialog.buttons} show={showPwdSuccessDialog}>
                    <Icon value="success" size="large"/>
                    <p className="wk-dialog-success">密码正确</p>
                </Dialog>
                <Button className="enter-btn delete-weuiafter" onClick={this.onOpenPwdDialog}>输入密码</Button>
            </div>
        )
    }
}

LecturePasswordLecture.contextTypes = {
    page: React.PropTypes.object,
};

export default connect((state) => ({
    lectureId: state.lecture.lecture.id,
    lectureMode: state.lecture.lecture.lecture_mode
}))(LecturePasswordLecture);


// WEBPACK FOOTER //
// ./src/components/lecture/LecturePasswordLecture.js